import React, { useState, useEffect, useRef } from 'react';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';

// Import all client images
import client1 from '../../assets/home/clients/client1.png';
import client2 from '../../assets/home/clients/client2.png';
import client3 from '../../assets/home/clients/client3.png';
import client4 from '../../assets/home/clients/client4.png';
import client5 from '../../assets/home/clients/client5.png';
import client6 from '../../assets/home/clients/client6.png';
import client7 from '../../assets/home/clients/client7.png';
import client8 from '../../assets/home/clients/client8.png';
import client9 from '../../assets/home/clients/client9.png';
import client10 from '../../assets/home/clients/client10.png';
import client11 from '../../assets/home/clients/client11.png';
import client12 from '../../assets/home/clients/client12.png';
import client13 from '../../assets/home/clients/client13.png';
import client14 from '../../assets/home/clients/client14.png';
import client15 from '../../assets/home/clients/client15.png';
import client16 from '../../assets/home/clients/client16.png';
import client17 from '../../assets/home/clients/client17.png';
import client18 from '../../assets/home/clients/client18.png';
import client19 from '../../assets/home/clients/client19.png';
import client20 from '../../assets/home/clients/client20.png';
import client21 from '../../assets/home/clients/client21.png';
import client22 from '../../assets/home/clients/client22.png';
import client23 from '../../assets/home/clients/client23.png';
import client24 from '../../assets/home/clients/client24.png';
import client25 from '../../assets/home/clients/client25.png';
import client26 from '../../assets/home/clients/client26.png';
import client27 from '../../assets/home/clients/client27.png';

const TestimonialsSection = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);
    const sectionRef = useRef(null);
    const autoPlayRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    // Auto-play functionality
    useEffect(() => {
        if (isAutoPlaying) {
            autoPlayRef.current = setInterval(() => {
                setCurrentIndex((prev) => (prev + 1) % testimonials.length);
            }, 5000);
        }

        return () => {
            if (autoPlayRef.current) {
                clearInterval(autoPlayRef.current);
            }
        };
    }, [isAutoPlaying]);

    const testimonials = [
        {
            id: 1,
            rating: 5,
            text: "RoadExpress has transformed our logistics process — fast deliveries, real-time tracking, and outstanding support. Highly recommend!",
            author: "Niraj Upadhyay",
            position: "Director Supply Chain",
            company: "Apollo Supply Chain",
            image: client21
        },
        {
            id: 2,
            rating: 5,
            text: "Outstanding service quality and reliability. RoadExpress has become our go-to partner for all logistics needs across India.",
            author: "Sandeep Malik",
            position: "Director Supply",
            company: "OM Logistics Ltd",
            image: client8
        },
        {
            id: 3,
            rating: 5,
            text: "The technology integration and real-time updates have revolutionized how we manage our supply chain. Exceptional team!",
            author: "Telu Ram",
            position: "Director",
            company: "Best Roadways Ltd",
            image: client26
        },
        {
            id: 4,
            rating: 5,
            text: "Professional, efficient, and always on time. RoadExpress has exceeded our expectations in every delivery.",
            author: "Ajay Rai",
            position: "Director",
            company: "DHL",
            image: client17
        },
        {
            id: 5,
            rating: 5,
            text: "Cost-effective solutions without compromising on quality. Their customer service is top-notch and very responsive.",
            author: "Abhishek Dhoknia",
            position: "Director",
            company: "DeHaat",
            image: client1
        },
        {
            id: 6,
            rating: 5,
            text: "RoadExpress's platform has streamlined our operations significantly. The real-time visibility and reliability are unmatched.",
            author: "Ankit Mehan",
            position: "Director Supply",
            company: "Delhivery",
            image: client2
        },
        {
            id: 7,
            rating: 5,
            text: "The seamless integration and efficient logistics solutions have helped us improve our delivery timelines considerably.",
            author: "Raghavendra Singh",
            position: "Supply Head",
            company: "Agarwal Packers and Movers",
            image: client6
        },
        {
            id: 8,
            rating: 5,
            text: "RoadExpress has been instrumental in optimizing our supply chain network. Their support team is exceptional.",
            author: "Rakesh Panday",
            position: "DGM",
            company: "Patanjali",
            image: client16
        },
        {
            id: 9,
            rating: 5,
            text: "A reliable partner for all our logistics needs. The technology platform and customer service are world-class.",
            author: "Ajay Khosla",
            position: "Country Head",
            company: "CCI Logistics Ltd",
            image: client22
        },
        {
            id: 10,
            rating: 5,
            text: "RoadExpress has transformed how we handle our logistics operations. Transparent pricing and excellent service delivery.",
            author: "Sachin Pathak",
            position: "Finance Head",
            company: "Synchronised Supply Chain Ltd",
            image: ""
        }
    ];

    const nextTestimonial = () => {
        setCurrentIndex((prev) => (prev + 1) % testimonials.length);
        setIsAutoPlaying(false);
    };

    const prevTestimonial = () => {
        setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
        setIsAutoPlaying(false);
    };

    const goToTestimonial = (index) => {
        setCurrentIndex(index);
        setIsAutoPlaying(false);
    };

    const renderStars = (rating) => {
        return Array.from({ length: 5 }, (_, index) => (
            <Star
                key={index}
                className={`w-5 h-5 ${index < rating ? 'text-yellow-400 fill-current' : 'text-gray-300'
                    }`}
            />
        ));
    };

    return (
        <section
            ref={sectionRef}
            className="w-full py-20 overflow-hidden"
            aria-labelledby="testimonials-section-title"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Section Header */}
                <div
                    className={`text-center mb-16 transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
                        }`}
                >
                    <h2
                        id="testimonials-section-title"
                        className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4"
                    >
                        What Our Clients Say
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Don't just take our word for it. Here's what our satisfied customers have to say about our logistics services.
                    </p>
                </div>

                {/* Testimonial Carousel Container */}
                <div className="relative">
                    {/* Main Testimonial Card */}
                    <div
                        className={`transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'
                            }`}
                        style={{ transitionDelay: '0.3s' }}
                    >
                        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mx-auto max-w-4xl relative overflow-hidden">
                            {/* Quote Icon */}
                            <div className="absolute top-6 left-6 text-[#F05A28]/20">
                                <Quote className="w-16 h-16" />
                            </div>

                            {/* Rating Stars */}
                            <div className="flex justify-center mb-6 relative z-10">
                                <div className="flex space-x-1">
                                    {renderStars(testimonials[currentIndex].rating)}
                                </div>
                            </div>

                            {/* Testimonial Text */}
                            <div className="text-center mb-8 relative z-10">
                                <p className="text-xl md:text-xl lg:text-2xl font-medium text-gray-800 leading-relaxed mb-8 italic">
                                    "{testimonials[currentIndex].text}"
                                </p>
                            </div>

                            {/* Author Info */}
                            <div className="flex items-center justify-center space-x-6 relative z-10">
                                <div className="text-center">
                                    <h4 className="text-lg font-bold text-gray-900 mb-1">
                                        {testimonials[currentIndex].author}
                                    </h4>
                                    <p className="text-sm text-gray-600">
                                        {testimonials[currentIndex].position}, {testimonials[currentIndex].company}
                                    </p>
                                </div>

                                {/* Client Image */}
                                {testimonials[currentIndex].image && (
                                    <div className="w-20 h-20 bg-white rounded-xl flex items-center justify-center p-3 border border-gray-200">
                                        <img
                                            src={testimonials[currentIndex].image}
                                            alt={`${testimonials[currentIndex].author}`}
                                            className="w-full h-full object-contain transition-all duration-300"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Navigation Controls */}
                    <div className="flex items-center justify-center space-x-4 mt-8">
                        {/* Dots Indicator */}
                        <div className="flex space-x-2">
                            {testimonials.map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => goToTestimonial(index)}
                                    className={`w-3 h-2 rounded-full transition-all duration-300 ${index === currentIndex
                                        ? 'bg-[#F05A28] w-8'
                                        : 'bg-gray-300 hover:bg-gray-400'
                                        }`}
                                    aria-label={`Go to testimonial ${index + 1}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* SEO Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name": "RoadExpress",
                    "review": testimonials.map(testimonial => ({
                        "@type": "Review",
                        "author": {
                            "@type": "Person",
                            "name": testimonial.author
                        },
                        "reviewBody": testimonial.text,
                        "reviewRating": {
                            "@type": "Rating",
                            "ratingValue": testimonial.rating,
                            "bestRating": 5
                        }
                    }))
                })}
            </script>
        </section>
    );
};

export default TestimonialsSection;